import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import NowrapDiv from 'components/common/NowrapDiv'

const VenderServiceInfoSimplified = ({ vender }) => {
  // 若後台設定廠商列表篩選項目為 true 才顯示
  const visibleServiceItems = (vender?.venderServiceItems || [])
    .map((serviceItem) =>
      serviceItem?.serviceClassification?.isVenderFilterListVisible
        ? serviceItem?.serviceClassification?.name
        : null
    )
    .filter(Boolean)

  const infos = []

  // 服務項目
  if (visibleServiceItems.length) {
    infos.push(
      <Box display="flex">
        <Typography
          minWidth={66}
          fontWeight="fontWeightBold"
          color="text.minus2"
          style={{ lineHeight: '24px' }}
        >
          <NowrapDiv>服務項目</NowrapDiv>
        </Typography>
        <Box ml={4} flexGrow={1}>
          <Typography style={{ lineHeight: '24px' }}>
            <Box color="text.minus2">{visibleServiceItems.join(' / ')}</Box>
          </Typography>
        </Box>
      </Box>
    )
  }

  // 服務區域
  if (vender?.introductionInfo?.serviceCounties?.length) {
    infos.push(
      <Box display="flex">
        <Typography
          minWidth={66}
          fontWeight="fontWeightBold"
          color="text.minus2"
          style={{ lineHeight: '24px' }}
        >
          <NowrapDiv>服務區域</NowrapDiv>
        </Typography>
        <Box ml={4} flexGrow={1}>
          <Typography style={{ lineHeight: '24px' }}>
            <Box color="text.minus2">
              {vender?.introductionInfo?.serviceCounties?.join('、')}
            </Box>
          </Typography>
        </Box>
      </Box>
    )
  }

  return (
    <>
      {infos.map((info, index) => (
        <Box mb={3} key={`info-${index}`}>
          {info}
        </Box>
      ))}
    </>
  )
}

export default VenderServiceInfoSimplified
